import { UrlBase } from './config'
import axios from 'axios'

const usersTasks = {}

usersTasks.deleteTask = async (token, companyId, appId, userId, taskId) => {
  try {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/tasks/${taskId}`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.getTaskOutcomes = async (token) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${UrlBase}task/outcomes`
    }
    const response = await axios(request)
    return response.data.outcomes
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.getTasks = async (token, companyId, appId, userId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        dateTimeUnit: 'HOUR',
        evaluator: 'all'
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/tasks`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.getTask = async (token, companyId, appId, userId, taskId) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/tasks/${taskId}`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.newTask = async (token, companyId, appId, userId, data) => {
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: { ...data },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/tasks`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.updateTask = async (token, companyId, appId, userId, task) => {
  try {
    const { extraData, date, done, id, name, observation, reportToUser, sendEmailNotificationTo, sendPhoneNotificationTo, type } = task
    const request = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: {
        id,
        name,
        date,
        observation,
        sendEmailNotificationTo,
        sendPhoneNotificationTo,
        extraData,
        done,
        reportToUser,
        type
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/users/${userId}/tasks/${id}`
    }
    await axios(request)
    return true
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.getTasksNotifications = async (token, appId, pagination) => {
  if (!pagination || typeof pagination !== 'object') {
    pagination = {
      itemsPerPage: 100,
      page: 1
    }
  }
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        appUUID: appId,
        limit: pagination.itemsPerPage,
        ascDesc: 'desc',
        page: pagination.page,
        evaluator: 'all',
        done: false
      },
      url: `${UrlBase}users/tasks/notifications`
    }
    const response = await axios(request)
    return response.data
  } catch (e) {
    const message = e.response
    if (message) {
      throw new Error(message.data.error)
    }
    throw new Error(e.message)
  }
}

usersTasks.createTypeOfTask = async (company, app, data) => {
  try {
    const { type } = data

    const request = {
      data: {
        type
      },
      method: 'POST',
      url: `${UrlBase}companies/${company}/apps/${app}/task/types`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

usersTasks.deleteTypeOfTasks = async (company, app, data) => {
  try {
    const { id } = data
    const request = {
      method: 'DELETE',
      url: `${UrlBase}companies/${company}/apps/${app}/task/types/${id}`
    }

    const response = await axios(request)

    return response.data
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

usersTasks.getTypeOfTasks = async (company, app) => {
  try {
    const request = {
      method: 'GET',
      url: `${UrlBase}companies/${company}/apps/${app}/task/types`
    }

    const response = await axios(request)

    return response.data.types
  } catch (e) {
    const message = e.response
    if (!message) throw new Error(e.message)
    else throw new Error(message.data.error)
  }
}

export default usersTasks
